import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { compose, withProps } from 'recompose';
import { routes, tabKeys } from '../../../../constants';
import { isManager, isMinimumBased } from '../../../../services';
import { currentUserCpdWeeksRemaining, currentUserIndustry, currentUserSelector } from '../../../../state/modules/user/selectors';
import { unfixedFloor } from '../../../../utils';
import { ProgressChart } from '../../../partials';

const ProgressHighlight = ({ children, showPublish, showExternalCpd, hideProgress }) => [
  <Row key={0}>
    {
      hideProgress ?
        null :
        <Col xs={12}>
          <div className='highlight--progress'>
            {children}
            <div className='clearfix' />
          </div>
        </Col>
    }
  </Row>
];

const ProgressCard = ({
  icon,
  cpdCategory,
  cpdWeeksRemaining,
  goal,
  shortFall,
  validCpd,
  progress,
  totalCpdCategorys,
  showPublish,
  showExternalCpd,
  isMinimumBased,
  isManager
}) => (
    ((totalCpdCategorys > 0) || isManager) ?
      <Col id='progress-card' xs={12} md={4} mdOffset={1}>
        <ProgressHighlight hideProgress={isManager} showPublish={showPublish} showExternalCpd={showExternalCpd}>
          <div className='chart'>
            {
              icon ?
                icon :
                <ProgressChart progressPercentage={progress} width={100} height={100} />
            }
          </div>
          <div className='info'>
            <h3>{cpdCategory ? `Progress for ${cpdCategory}` : 'Progress'}</h3>
            {
              goal ?
                <p>{`${unfixedFloor(shortFall > 0 ? goal - shortFall : validCpd, 2)}/${goal} CPD Hours completed`}</p> :
                <p>{`${unfixedFloor(shortFall > 0 ? goal - shortFall : validCpd, 2)} CPD Hours completed`}</p>
            }
            {
              cpdWeeksRemaining ?
                <p><span>{cpdWeeksRemaining} weeks to go</span></p> :
                null
            }
          </div>
        </ProgressHighlight>
      </Col> :
      <Col id='progress-card' xs={12} md={5} lg={4} lgOffset={1}>
        <ProgressHighlight showPublish={showPublish}>
          <div className='manage-account text-center'>
            <p>Click here to set up your CPD categories so you can track your progress</p>
            <LinkContainer to={routes.app.trainingPlansSettings(tabKeys.trainingPlansSettings.userTrainingPlan)}>
              <Button>Set up your CPD preferences</Button>
            </LinkContainer>
          </div>
        </ProgressHighlight>
      </Col>
  );

const mapStateToProps = (state) => ({
  cpdCategorys: state.cpdCategorys.cpdCategorys,
  industryCpdCategorys: state.industry.cpdCategorys,
  isMinimumBased: isMinimumBased(currentUserIndustry(state)),
  cpdWeeksRemaining: currentUserCpdWeeksRemaining(state),
  currentUser: currentUserSelector(state)
});

export default compose(
  connect(mapStateToProps),
  withProps(
    ({ cpdCategorys, cpdCategory, currentUser, icon }) => ({
      isManager: isManager(currentUser),
      icon: icon ? icon : fp.flow(
        fp.find(({ name }) => name === cpdCategory),
        fp.get('iconUrl'),
        (url) => url ? <img className="category-icon" src={he.decode(url)} alt={cpdCategory} /> : null
      )(cpdCategorys)
    })
  )
)(ProgressCard);



// WEBPACK FOOTER //
// ./src/containers/pages/app/partials/progress-card.js